/**
 * 官方认证配置页面
 */
import './official-auth.css';
import React, {Component} from 'react';

class OfficialAuth extends Component{
    static defaultProps = {
        value: 0
    }

    constructor(props){
        super(props);
        
        this.state = {
            value: props.value
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        })   
    }
    
    render() {
        return <i className="ui-auth" data-auth={this.state.value}></i>;
    }
}

export default OfficialAuth;



// WEBPACK FOOTER //
// ./js/component/user-ui/official-auth.js